import Image from "next/image";

export default function CompanyInfo({ locale }: { locale: string }) {
  return (
    <div className="lg:col-span-5 space-y-6">
      <Image
        src="/light-logo.png"
        alt="Logo"
        width={140}
        height={30}
        className="brightness-125"
      />
      <p className="text-base text-white/60 leading-relaxed max-w-sm">
        {locale === "ar"
          ? "الدولية هي مزود متكامل لأنظمة الألمنيوم المعمارية تقدم حلول الواجهات، الجدران الستائرية، النوافذ، والأبواب مدعومة بتقنيات البثق الداخلي، التشطيب المتقدم، والفصل الحراري."
          : "Al Dawlia is an integrated architectural aluminum system provider delivering engineered façade, curtain wall, window, and door solutions supported by in-house extrusion, advanced finishing, and thermal break technologies."}
      </p>
    </div>
  );
}
